// src/components/modules/WhereReadersLand.jsx
// The aggregate view of one fork: how readers across the app answered.
// Shown ONLY after this reader has committed — the same never-lead-the-
// witness rule as the lens lines. Below a minimum crowd size it shows an
// honest count instead of percentages, because "100% of 3 readers" is
// noise wearing a suit.
import React from 'react';
import { Users } from 'lucide-react';

// Percentages appear once this many devices have taken a position.
export const MIN_READERS_FOR_SPLIT = 10;

const WhereReadersLand = ({ point, aggregate, ownChoice, compact = false }) => {
  if (!aggregate) return null;
  const total = aggregate.total || 0;
  const counts = aggregate.counts || {};

  return (
    <div className={compact ? 'mt-3' : 'mt-4 pt-4 border-t border-violet-500/20'}>
      <div className="flex items-center gap-2 mb-2">
        <Users className="w-4 h-4 text-violet-300" />
        <span className="text-xs font-semibold tracking-wide uppercase text-violet-300">
          Where readers land
        </span>
      </div>

      {total < MIN_READERS_FOR_SPLIT ? (
        <p className="text-sm text-slate-400">
          {total <= 1
            ? 'You are the first reader on record at this fork.'
            : `Early days: ${total} readers have taken a position here so far, counted one per device. The split appears once there are ${MIN_READERS_FOR_SPLIT}.`}
        </p>
      ) : (
        <div className="space-y-2">
          {point.options.map((option) => {
            const n = Math.max(0, counts[option.id] || 0);
            const pct = Math.round((n / total) * 100);
            const isOwn = option.id === ownChoice;
            return (
              <div key={option.id}>
                <div className="flex items-baseline justify-between gap-3 mb-1">
                  <span className={`text-sm ${isOwn ? 'text-violet-200 font-semibold' : 'text-slate-400'}`}>
                    {option.label}
                    {isOwn && <span className="ml-2 text-xs text-violet-300">(you)</span>}
                  </span>
                  <span className={`text-sm tabular-nums ${isOwn ? 'text-violet-200 font-semibold' : 'text-slate-400'}`}>
                    {pct}%
                  </span>
                </div>
                <div className="h-1.5 rounded-full bg-slate-700/60 overflow-hidden">
                  <div
                    className={`h-full rounded-full ${isOwn ? 'bg-violet-400' : 'bg-slate-500'}`}
                    style={{ width: `${pct}%` }}
                  />
                </div>
              </div>
            );
          })}
          <p className="text-xs text-slate-400 pt-1">
            {total.toLocaleString()} readers have taken a position here, counted one per device.
          </p>
        </div>
      )}
    </div>
  );
};

export default WhereReadersLand;
